var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgImportTemplateIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 0.666667C13.3333 0.29848 13.0349 0 12.6667 0H0.666667C0.29848 0 0 0.29848 0 0.666667V11.3333C0 11.7015 0.29848 12 0.666667 12H12.6667C13.0349 12 13.3333 11.7015 13.3333 11.3333V0.666667ZM1.33333 8H3.61069C4.12507 9.17727 5.29979 10 6.66667 10C8.03353 10 9.20827 9.17727 9.72267 8H12V10.6667H1.33333V8ZM1.33333 1.33333H12V6.66667H8.66667C8.66667 7.77127 7.77127 8.66667 6.66667 8.66667C5.56207 8.66667 4.66667 7.77127 4.66667 6.66667H1.33333V1.33333ZM9.33333 4H7.33333V2H6V4H4L6.66667 7L9.33333 4Z",
    fill: "#FC6328"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgImportTemplateIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ImportTemplateIcon.f4df6b11.svg";
export { ForwardRef as ReactComponent };